/* eslint-disable @typescript-eslint/ban-ts-comment */
import Keycloak from "keycloak-js";
import { resetSessionStores } from "./hooks/session-storage/create-session-store";
import { resetUser } from "./services/mix-panel/mix-panel-util";
import {
  clearAuthTokens,
  setViewAs,
  getStoredRealm,
  setStoredRealm,
  setStoredRole,
  setKeycloakToken,
} from "@/utils/auth-storage";

const env = import.meta.env.VITE_ENV_NAME;
const hostNameArr = location.hostname?.split(".");
const portal = hostNameArr[2];
// const urlParams = new URLSearchParams(window.location.search);

// https://dev_varade123.dev.provider.ecarehealth.com/
// https://stage_thunderstormhosp034.uat.provider.ecarehealth.com/

//["uat", "admin", "ecarehealth", "com"]
//["uat", "provider", "ecarehealth", "com"]

//["app", "env", "admin", "ecarehealth", "com"]
//["env_realm", "env", "provider", "ecarehealth", "com"]

const params = new URLSearchParams(location.search);
// const realm = params.get("realm") || "";
export function getRealm(host: Array<string>) {
  if (env === "prod") {
    if (host[0] === "app") return undefined;

    return host[0];
  }

  if (host[0] === "localhost") {
    return params.get("realm");
  }

  if (portal === "provider" || portal === "patient") {
    if (env === "dev" || env === "qa") {
      return host[0];
    } else if (env === "sandbox") {
      return host[0];
    }
  }

  return import.meta.env.VITE_KEYCLOAK_REALM === "master"
    ? undefined
    : import.meta.env.VITE_KEYCLOAK_REALM;
}

const realm = getRealm(hostNameArr);

if (realm) setStoredRealm(realm);

const getRoleFromAccessToken = (): string => {
  const roles = keycloak.realmAccess?.roles || [];

  const filteredRoles = roles.filter((role) => role === role.toUpperCase());
  const role = filteredRoles[0];
  return role || "";
};

const keycloak = new Keycloak({
  url: import.meta.env.VITE_KEYCLOAK_AUTH_URL,
  realm:
    realm === "none"
      ? import.meta.env.VITE_KEYCLOAK_REALM === "master"
        ? undefined
        : import.meta.env.VITE_KEYCLOAK_REALM
      : realm ||
          getStoredRealm()?.replace(/"/g, "") ||
          import.meta.env.VITE_KEYCLOAK_REALM === "master"
        ? undefined
        : import.meta.env.VITE_KEYCLOAK_REALM,
  clientId: import.meta.env.VITE_KEYCLOAK_CLIENTID,
});

try {
  //  @ts-ignore
  await keycloak.init({
    onLoad: "check-sso",
    silentCheckSsoRedirectUri: `${location.origin}/silent-check-sso.html`,
    scope: "openid",
    redirectUri: location.origin,
    flow: "standard",
  });

  if (keycloak.authenticated) {
    const role = getRoleFromAccessToken();
    if (["PATIENT"]?.includes(role)) {
      setViewAs("patient");
    } else if (role && role === "SUPER_ADMIN") {
      setViewAs("admin");
    } else if (
      role &&
      [
        "PROVIDER_GROUP_ADMIN",
        "PSYCHIATRIST",
        "THERAPIST",
        "NURSE",
        "PROVIDER",
      ]?.includes(role)
    ) {
      setViewAs("provider");
    }
    setStoredRole(role);
    setKeycloakToken(keycloak?.token ?? "");
  } else {
    console.error("User is not authenticated");
  }
} catch (error) {
  console.error("Error initializing Keycloak:", error);
}

/**
 * Unregister the Firebase messaging service worker so the device stops
 * receiving push notifications after logout. Errors are swallowed so a
 * failure here can never block the logout flow.
 */
export const unregisterFcmServiceWorker = async (): Promise<void> => {
  try {
    if (!("serviceWorker" in navigator)) return;

    const registrations = await navigator.serviceWorker.getRegistrations();
    await Promise.all(
      registrations
        .filter((registration) =>
          registration.active?.scriptURL?.includes("firebase-messaging-sw.js")
        )
        .map((registration) => registration.unregister())
    );
  } catch (e) {
    console.error("Failed to unregister FCM service worker", e);
  }
};

export const logoutUser = async (): Promise<any> => {
  resetUser();
  await unregisterFcmServiceWorker();
  clearAuthTokens();
  sessionStorage.clear();
  resetSessionStores();
  return keycloak.logout({ redirectUri: window.location.origin });
};
